<template>
	<div class="group-nav-panel" v-if="show">
		<el-timeline>
			<el-timeline-item v-for="(item, index) in groupsForm" :key="index">
				<span
					:class="{ active: activeIndex == index, smallFont: !item.child }"
					@click="getActiveIndex(index)"
					>{{ item.name }}</span
				>
				<i slot="dot" class="iconfont iconDot1" v-show="activeIndex == index"></i>
			</el-timeline-item>
		</el-timeline>
	</div>
</template>
<script>
export default {
	name: 'GroupNavPanel',
	props: {
		groupsForm: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
			activeIndex: 0,
			show: false,
		};
	},
	mounted() {
		window.addEventListener('scroll', this.scrollEvent);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.scrollEvent);
	},
	methods: {
		scrollEvent() {
			let scrollItems = document.querySelectorAll('.scroll-item');

			if (scrollItems.length) {
				// 获取距离顶部的距离
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

				// 获取可视区的高度
				let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				// 获取滚动条的总高度
				let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

				this.show = scrollTop >= scrollItems[0].offsetTop - 150 ? true : false;

				for (let i = scrollItems.length - 1; i >= 0; i--) {
					// 判断滚动条滚动距离是否大于当前滚动项可滚动距离
					let judge = scrollTop >= scrollItems[i].offsetTop - 100;

					if (judge) {
						this.activeIndex = i;
						break;
					}
				}
				// 滚动条触底了
				if (scrollTop + windowHeight + 1 >= scrollHeight) {
					this.activeIndex = this.groupsForm.length - 1;
				}
			}
		},

		getActiveIndex(index) {
			this.activeIndex = index;
			let jump = document.querySelectorAll('.scroll-item');
			jump[index].scrollIntoView({
				block: 'start',
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.group-nav-panel {
	width: 300px;
	height: 300px;
	overflow-y: scroll;
	overflow-x: hidden;
	position: fixed;
	top: 100px;
	right: 30px;
	z-index: 999;
	background-color: #ffffff;
	box-shadow: 0 2px 10px 0 #eaeaea;
	padding: 24px 18px 0px 18px;
	border-radius: 4px;

	.active {
		color: #3389fd !important;
	}

	.iconDot1 {
		font-size: 10px;
		width: 10px;
		height: 10px;
		border-radius: 5px;
		border: 1px #3389fd solid;
		background-color: #fff;
	}

	.el-timeline {
		padding-inline-start: 0;

		:last-child {
			padding-bottom: 0;
		}

		.el-timeline-item__content {
			cursor: pointer;

			&:hover {
				color: #3389fd;
			}
		}
		.el-timeline-item {
			padding-bottom: 10px;
			:last-child {
				padding-bottom: 0 !important;
			}
		}
		.el-timeline-item__tail {
			top: 5px;
		}
	}
	.smallFont {
		display: inline-block;
		font-size: 12px;
		color: #666666;
		padding-left: 25px;
		text-align: left;
		cursor: pointer;
	}
}
.group-nav-panel::-webkit-scrollbar {
	position: relative;
	width: 6px;
}
.group-nav-panel::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 5px rgba(144, 147, 153, 0.3);
	background: rgba(163, 155, 155, 0.2);
}
.group-nav-panel::-webkit-scrollbar-track {
	/* box-shadow: inset 0 0 5px rgba(144, 147, 153, 0.3); */
	border-radius: 0;
	/* background: rgba(193, 185, 185, 0.1); */
}
</style>
